import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Product } from 'ts/types/Product'
import CardTable from 'components/CardTable'
import { Boolean as BooleanCell } from 'components/ui'
import ProductAddPage from './ProductAddPage'
import useFetchSafe from 'hooks/useFetchSafe'
import { useTrader } from 'context/TraderTypeContext';

// Define the interface for the items in SubClassOpt.data
interface SubClassItem {
    subclassId: number;
    name: string;
}

const ProductPage = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();
  const SubClassOpt = useFetchSafe(Url.getSubclass)
const columns: Column<Product>[] = [
  {
    Header: 'ID',
    accessor: 'productId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Product Name',
    accessor: 'name'
  },
    // {
    //   Header: 'Image',
    //   accessor: 'productImage'
    // },
  {
    Header: 'SKU',
    accessor: 'sku'
  },
  // {
  //   Header: 'Category',
  //   accessor: 'category'
  // },
  // {
  //   Header: 'Sub Category',
  //   accessor: 'subCategory'
  // },
  // {
  //   Header: 'Department',
  //   accessor: 'departmentName'
  // },
  // {
  //   Header: 'Class',
  //   accessor: 'className'
  // },
  {
    Header: 'Sub Class',
    accessor: 'subclassId',
    Cell: ({ value }: { value: number }) => {
      const subClassName = (SubClassOpt.data as SubClassItem[]).find(item => item.subclassId == value)?.name || 'Unknown';
      return subClassName;
    }
  },
  {
    Header: '',
    accessor: 'productTypeId',
    Cell: ''
  },
  {
    Header: '',
    accessor: 'flOpenPrice',
    Cell: ''
  },
  {
    Header: '',
    accessor: 'buttonStyleId',
    Cell: ''
  },
  {
    Header: '',
    accessor: 'thorProductId',
    Cell: ''
  },
  {
    Header: '',
    accessor: 'traderId',
    Cell: ''
  },

]

  return (
    <CardTable
      columns={columns}
      dataKey={Url.getProduct.toString()}
      url={Url.getProduct(traderId)}  
      modalChild={<ProductAddPage />}
    />
  )
}

export default ProductPage
